

export class TyreStatusInput implements ITyreStatusInput {
    /** The auto-generated id of the tyre master */
    tyreId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITyreStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyreId = _data["tyreId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TyreStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyreId"] = this.tyreId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITyreStatusInput {
    /** The auto-generated id of the tyre master */
    tyreId: number;
    /** The updated status */
    status: number;
}

